(function () {
  // Stromo: verzendbelofte dynamisch bijwerken op basis van de lokale tijd van
  // de bezoeker. Server-side (Liquid) tonen we altijd de veilige standaardtekst;
  // hier corrigeren we client-side naar de juiste boodschap na de cutoff-tijd
  // (15:00) of in het weekend, zodat we nooit een onjuiste belofte tonen.
  function updateBadges() {
    var now = new Date();
    var day = now.getDay(); // 0 = zo, 6 = za
    var hour = now.getHours();
    var isWeekday = day >= 1 && day <= 5;
    var beforeCutoff = isWeekday && hour < 15;

    var text = beforeCutoff
      ? 'Voor 15:00 besteld, dezelfde dag verzonden'
      : 'Besteld, eerstvolgende werkdag verzonden';

    document.querySelectorAll('[data-stromo-shipping-text]').forEach(function (el) {
      el.textContent = text;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBadges);
  } else {
    updateBadges();
  }
})();
